import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdiSvg"
  },

  theme: {
    themes: {
      light: {
        primary: "#42CCCC",
        secondary: "#42CCCC",
        tertiary: "#363847",
        accent: "#363847",
        dark_grey: "#363847",
        error: "#FF4766",
        watermelon: "#FF4766",
        body: "#363847",
        white: "#FFFFFF",
      },
      dark: {
        primary: "#42CCCC",
        secondary: "#363847",
        tertiary: "#7771FF",
        accent: "#2e2d7f",
        dark_grey: "#2B2B2B",
        error: "#f1667c",
        body: "#7d8a95",
        white: "#FFFFFF",
      }
    }
  }
});
